import * as actionTypes from 'constants/ActionTypes';

export function getCargoTypes() {
    return {
        type: actionTypes.GET_CARGO_TYPES.REQUEST,
    };
}



// WEBPACK FOOTER //
// ./app/actions/cargoes/types.js